import FlyOutBasketIcon from './FlyOutBasketIcon';

const variants = {
  flyoutBasketIcon: FlyOutBasketIcon
};

export default variants;
